<template>
  <div class="error-page">
    <div class="content-con">
      <img :src="src" :alt="code">
      <div class="text-con">
        <h4>{{ code }}</h4>
        <h5>{{ desc }}</h5>
      </div>
      <back-btn-group class="back-btn-group"></back-btn-group>
    </div>
  </div>
</template>

<script>
import backBtnGroup from './back-btn-group.vue'
export default {
  name: 'error_content',
  components: {
    backBtnGroup
  },
  props: {
    code: String,
    desc: String,
    src: String
  }
}
</script>
<style>
.error-page{
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
}
.content-con{
    width: 700px;
    height: 600px;
    position: absolute;
    left: 50%;
    top: 60%;
    transform: translate(-50%, -60%);
}
.content-con img{
    display: block;
    margin-top:60px;
    width: 700px;
    height: 540px;
}
.text-con{
    position: absolute;
    left: 0px;
    top: 0px;
}
.content-con h4{
    position: absolute;
    left: 0px;
    top: 0px;
    font-size: 40px;
    font-weight: 700;
    color: #348EED;
}
.content-con h5{
    position: absolute;
    width: 700px;
    left: 0px;
    top: 50px;
    font-size: 20px;
    font-weight: 700;
    color: #67647D;
}
.back-btn-group{
    position: absolute;
    right: 0px;
    bottom: 20px;
}
</style>
